import React from "react";
import { useApp } from "@/context/AppContext";
import { Home, ListOrdered, CreditCard, UserRound, ShieldCheck } from "lucide-react";

export default function BottomNav({ tab, onTab, isAdmin }) {
  const { t } = useApp();
  const items = [
    { key: "home", icon: Home, label: t.navHome },
    { key: "activity", icon: ListOrdered, label: t.navActivity },
    { key: "card", icon: CreditCard, label: t.navCard },
    { key: "profile", icon: UserRound, label: t.navProfile },
    ...(isAdmin ? [{ key: "admin", icon: ShieldCheck, label: t.navAdmin }] : []),
  ];
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-40 flex justify-center pointer-events-none"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="pointer-events-auto w-full max-w-md bg-background/85 backdrop-blur-xl border-t border-border/70 px-2 pt-1.5 pb-2 flex">
        {items.map((it) => {
          const active = tab === it.key;
          return (
            <button
              key={it.key}
              data-testid={`nav-${it.key}`}
              onClick={() => onTab(it.key)}
              aria-current={active ? "page" : undefined}
              className={`flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-xl transition-colors ${active ? "text-primary" : "text-muted-foreground hover:text-foreground"}`}
            >
              <span className={`h-7 w-12 grid place-items-center rounded-full transition-colors ${active ? "bg-primary/12" : ""}`}>
                <it.icon className="w-5 h-5" strokeWidth={active ? 2.4 : 1.9} />
              </span>
              <span className="text-[10.5px] font-semibold">{it.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
